// Du vendredi 30 octobre 0h au lundi 2 novembre 0h, heure de Paris (UTC+1 depuis le 25 octobre).
const HALLOWEEN_WEEKEND_START = Date.parse('2026-10-30T00:00:00+01:00');
const HALLOWEEN_WEEKEND_END = Date.parse('2026-11-02T00:00:00+01:00');

export function isHalloweenLogoActive(now: number, search: string): boolean {
  if (new URLSearchParams(search).has('bouh')) return true;
  return now >= HALLOWEEN_WEEKEND_START && now < HALLOWEEN_WEEKEND_END;
}
